import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IllustrationLockedSvg } from "./IllustrationLockedSvg.mjs";
const IllustrationLocked = () => /* @__PURE__ */ jsx(Box, { component: IllustrationLockedSvg });
export {
  IllustrationLocked
};
